import { cn } from "@common/lib/utils"

export function FieldBox({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}): React.ReactElement {
  return (
    <div
      className={cn(
        "flex w-full items-stretch overflow-hidden rounded-md border border-input focus-within:ring-1 focus-within:ring-ring focus-within:ring-offset-2",
        className,
      )}
    >
      {children}
    </div>
  )
}

export const BARE_CONTROL =
  "h-full rounded-none border-0 bg-transparent px-2 py-0 text-left leading-none shadow-none focus-visible:ring-0 focus-visible:ring-offset-0"
